
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'pdf',
    },
    noAttachment: {
      type: Boolean,
      default: true,
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    noDetail: {
      type: Boolean,
      default: false,
    },
  },
}
